import { Language } from 'store/slices/language-slice';

interface ProfileViewMessages {
  profileViewMessages: {
    tickAlt: string;
    countryLabel: string;
    verificationStatusLabel: string;
    verifiedLabel: string;
    unverifiedLabel: string;
    verifyAlt: string;
    verifyButton: string;
    sourceOfFundsButton: string;
    verificationPendingButton: string;
    sendSmsButton: string;
    twoFactorAlt: string;
    otpAlt: string;
    twoFactorStatusLabel: string;
    otpStatusLabel: string;
    twoFactorEnabled: string;
    twoFactorDisabled: string;
    enableTwoFactorButton: string;
    disabledTwoFactorButton: string;
    enableOtpButton: string;
    emailNotificationAlt: string;
    emailNotificationLabel: string;
    emailNotificationDisabled: string;
    emailNotificationEnabled: string;
    disableNotificationsModalBody: string;
    yesButton: string;
    noButton: string;
    disableNotificationsAlt: string;
    otpEnabled: string;
    otpDisabled: string;
  };
}

type Message = {
  [key in Language]: ProfileViewMessages;
};

const messages: Message = {
  en: {
    profileViewMessages: {
      tickAlt: 'Profile Verified',
      countryLabel: 'Country',
      verificationStatusLabel: 'Verification Status',
      verifiedLabel: 'Verified',
      sourceOfFundsButton: 'Upload',
      verificationPendingButton: 'Verification in progress',
      sendSmsButton: 'Send SMS',
      unverifiedLabel: 'Unverified',
      verifyAlt: 'Verify account',
      verifyButton: 'Verify',
      twoFactorAlt: 'Two factor',
      otpAlt: 'OTP',
      twoFactorStatusLabel: '2FA Status',
      twoFactorEnabled: 'Enabled',
      twoFactorDisabled: 'Disabled',
      enableTwoFactorButton: 'Enable',
      disabledTwoFactorButton: 'Disable',
      emailNotificationAlt: 'Email Notifications',
      emailNotificationLabel: 'Email Login Notifications',
      emailNotificationEnabled: 'On',
      emailNotificationDisabled: 'Off',
      disableNotificationsModalBody:
        'Are you sure you want to stop receiving login notifications via email?',
      yesButton: 'Yes',
      noButton: 'No',
      disableNotificationsAlt: 'Altify - Exclamation',
      otpEnabled: 'Enabled',
      otpDisabled: 'Disabled',
      otpStatusLabel: 'OTP Status',
      enableOtpButton: 'Enable OTP',
    },
  },
};

export default messages;
